import { useState } from 'react';
import './styles/global.css';
import './App.css';

import Navigation from './components/Navigation/Navigation';
import LegalModal from './components/LegalModal/LegalModal';
import ShopModal from './components/ShopModal/ShopModal';
import CookieBanner from './components/CookieBanner/CookieBanner';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import Aktuelles from './components/Aktuelles/Aktuelles';
import CoffeeSection from './components/CoffeeSection/CoffeeSection';
import Patisserie from './components/Patisserie/Patisserie';
import KuecheSection from './components/KuecheSection/KuecheSection';
import Weinkeller from './components/Weinkeller/Weinkeller';
import ShopBanner from './components/ShopBanner/ShopBanner';
import Gruendung from './components/Gruendung/Gruendung';
import Alexandra from './components/Alexandra/Alexandra';
import Michael from './components/Michael/Michael';
import SignatureCakes from './components/SignatureCakes/SignatureCakes';
import Events from './components/Events/Events';
import Press from './components/Press/Press';
import KunstRocaille from './components/KunstRocaille/KunstRocaille';
import Footer from './components/Footer/Footer';

function App() {
  const [legalModal, setLegalModal] = useState(null);
  const [shopOpen, setShopOpen] = useState(false);

  return (
    <div className="app">
      {legalModal && (
        <LegalModal type={legalModal} onClose={() => setLegalModal(null)} />
      )}
      {shopOpen && (
        <ShopModal onClose={() => setShopOpen(false)} />
      )}
      <CookieBanner onOpenLegal={setLegalModal} />
      <Navigation onOpenShop={() => setShopOpen(true)} />

      <main>
        {/* 1. Hero */}
        <Hero />

        {/* 2. Intro – Willkommen + Video */}
        <Intro />

        {/* 2b. Aktuelles – Posts aus Sanity */}
        <Aktuelles />

        {/* 3. Kaffee */}
        <CoffeeSection />

        {/* 4. Patisserie */}
        <Patisserie />

        {/* 5. Marktfrische Küche */}
        <KuecheSection />

        {/* 6. Weinkeller */}
        <Weinkeller />

        {/* 7. Shop Banner */}
        <ShopBanner onOpenShop={() => setShopOpen(true)} />

        {/* 8. Events & Veranstaltungen */}
        <Events />

        {/* 9. Signature Cakes */}
        <SignatureCakes />

        {/* 10. Gründung */}
        <Gruendung />

        {/* 11. Alexandra Wende */}
        <Alexandra />

        {/* 12. Michael B. Spreckelmeyer */}
        <Michael />

        {/* 13. Presse */}
        <Press />

        {/* 14. Kunst Rocaille */}
        <KunstRocaille />

      </main>

      <Footer onOpenLegal={setLegalModal} />
    </div>
  );
}

export default App;
